import React from 'react';
import { IBaseLoginResponse } from './IBaseLoginResponse';

interface IContext {
	handleLogin: (response: IBaseLoginResponse) => void;
}

export const LoginContext = React.createContext<IContext>(undefined as any);
